import React, { useContext } from 'react'
import styled from 'styled-components'
import { Linea } from './Linea'
import { Icon } from '@iconify/react/dist/iconify.js'
import { ICON_TYPES } from '../constantes/iconos.ts'
import { ContextoDonacion } from '../contextos/Donacion.js'
import { useNavigate } from 'react-router-dom'
import { noticias } from '../listas/noticias.js'

const Resumen = () => {
    const listaNoticias = noticias
    const navigate = useNavigate()
    const { cambiar } = useContext(ContextoDonacion)
    return (
        <Container>
            <Largos>
                <Largo onClick={() => cambiar()}>
                    <Titulo>DONACIONES</Titulo>
                    <Linea color='white' />
                    <Contenido>
                        <Icon icon={ICON_TYPES.DONACION} style={{ fontSize: '36px' }} />
                        <p>Has clic para ayudarnos con una donación voluntaria</p>
                    </Contenido>
                </Largo>
                <Largo onClick={() => navigate('/Lacrosse')}>
                    <Titulo>LACROSSE CONEXION</Titulo>
                    <Linea color='white' />
                    <Contenido>
                        <p>Conoce nuestro trabajo semanal con Lacrosse conexión</p>
                        <Icon icon={ICON_TYPES.LACROSSE} style={{ fontSize: '36px' }} />
                    </Contenido>
                </Largo>
                <Cortos>
                    <Corto onClick={() => navigate('/Calendario')} >
                        <div>
                            <Titulo>Conoce Nuestro Calendario</Titulo>
                            <Linea color='white' />
                        </div>
                        <Icon icon={ICON_TYPES.CALENDARIO} style={{ fontSize: '100px' }} />
                    </Corto>
                    <Corto onClick={() => navigate('/Galeria')}>
                        <div>
                            <Titulo>Visita Nuestra Galería</Titulo>
                            <Linea color='white' />
                        </div>
                        <Icon icon={ICON_TYPES.GALERIA} style={{ fontSize: '100px' }} />
                    </Corto>
                </Cortos>
            </Largos>
            <Noticias>
                <div style={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <Titulo>Noticias</Titulo>
                    <Linea color='white' />
                </div>
                <Contenedor>
                    {listaNoticias.length > 0 ? noticias.map((element) => {
                        return (<Noticia>
                            <Imagen src={element.imagen} />
                            <Articulo>
                                <h1>{element.titulo}</h1>
                                <p>{element.parrafo}</p>
                            </Articulo>
                        </Noticia>)
                    }) : <Texto><h1>Aun no hay noticias</h1></Texto>}
                </Contenedor>
            </Noticias>
        </Container>

    )
}

const Container = styled.section`
    display: flex;
    flex-wrap: wrap;
    padding: 20px;
    justify-content: space-between;
    & article{
        cursor: pointer;
        transition: all .5s ease;
    }
    & article:hover{
        box-shadow: 4px 4px 10px #000;
        border: 1px solid white;
    }
`
const Largos = styled.div`
    width: max(500px, 50%);
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    gap: 20px;
    margin-bottom: 20px;
`
const Largo = styled.article`
    padding: 15px;
    border-radius: 20px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    background-color: var(--primary);
    color: white;
`

const Cortos = styled.div`
    display:flex;
    justify-content: space-between;
    align-items: center;
    width:100%;
`
const Corto = styled.article`
    padding: 15px;
    width: 45%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background-color: var(--secundary);
    color: white;
    border-radius: 20px;
    gap: 10px;
`
const Titulo = styled.p`
    font-size: 20px;
    text-align: center;
    color: white;
`

const Contenido = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 15px;
    align-items: center;
    gap: 10%;
`
const Noticias = styled.article`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    width: max(40%, 500px);
    background-color: var(--primary);
    border-radius: 20px;
    padding: 15px;
    gap: 20px;
`
const Contenedor = styled.div`
    overflow-y: scroll;
    width: 100%;
    height: 400px;
    background-color: white;
`
const Noticia = styled.div`
    gap: 20px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    border-bottom: 1px solid black;
    cursor: pointer;
    &:hover{
        background-color: #555;
        color: white;
    }
`
const Imagen = styled.img`
    height: 60px;
    width: 60px;
`
const Articulo = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

const Texto = styled.div`
    margin: auto;
    color: #444;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

`

export default Resumen